import { ConfirmDialog } from '@gogame/components';
import { useScreenMessage, useScreenModalV2 } from '@gogame/screens';

import { sendToAppsFlyer } from 'scenes/Events/sources/events';

export const useSendToAppsFlyer = () => {
  const { showErrorMessage, showSuccessMessage } = useScreenMessage();
  const showModal = useScreenModalV2(ConfirmDialog);
  return (params) => {
    return showModal({
      title: `Send Event To Apps Flyer?`,
      confirmActionLabel: 'Send',
      bodyText: `«${params.eventName}»`,
    }).then(() => {
      return sendToAppsFlyer(params)
        .catch((e) => {
          showErrorMessage(e.message);
          return Promise.reject(e);
        })
        .then((message) => {
          showSuccessMessage(message);
        });
    });
  };
};
